import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorKey } from '../app-active-error/ErrorKey';
import StandardError from '../app-active-error/StandardError';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { redirectToUrl } from '../utils/redirectToUrl';
import { leadsKnowledgeBaseArticle } from '../signup-completed-redirection/productLinks';

const PartnerNoRegisteredLeadsView = () => {
  const dispatch = useDispatch();
  const handleButtonClick = useCallback(() => dispatch(redirectToUrl(leadsKnowledgeBaseArticle())), [dispatch]);
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: ErrorKey.PartnerNoRegisteredLeads,
    handleButtonClick: handleButtonClick
  });
};

export default PartnerNoRegisteredLeadsView;